import React, { Fragment, useEffect, useState } from "react";
import TeamNotify from "./TeamNotify";
import EmailNotify from "./EmailNotify";
import RawDataPersist from "./RawDataPersist";
import DataQuality from "./DataQuality";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Box, Button } from "@material-ui/core";
import { Card, Tooltip } from "react-bootstrap";
import {
  getAllSysConfig,
  getApiUserRoles,
  getSystemProvider,
} from "../../../Utils/actions";
import { appSetting } from "../../Common/headerName";
import BackendJobs from "./BackendJobs";
import EmailConfig from "./EmailConfig";
import TemplateServer from "./TemplateServer";
import "./ApplicationCnfig.scss";
import NodeInfoPage from "./NodeInfoPage";
import KeyVault from "./KeyVault";
import Cluster from "./cluster";

const ApplicationCnfig = () => {
  const [tabsValue, setTabsValue] = useState(0);
  const [checkBackedSet, setCheckBackedSet] = useState(false);
  const [render, setRender] = useState("cleanUpTab");
  const { dataProvider, rigsData, bUnitData, nodeInfo } = useSelector(
    (state) => state.data
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));
    // dispatch(getAllSysConfig({ pageSize: 10, pageNumber: 1 }));
    dispatch(getSystemProvider());
  }, []);

  const setTabs = (tabsIndex) => {
    if (tabsIndex === 1) {
      setCheckBackedSet(true);
    }
    setTabsValue(tabsIndex);
  };

  const appRender = (value) => {
    setRender(value.value[0]);
  };

  // setCookie('cookieName', 'cookieValue', { path: '/' });
  const cmpntGroup =
    sessionStorage.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage.getItem("cmpntGroup"))
      : "{}";

  const isButtonDisabled = (value) => {
    if (value === "nodeInfoTab") {
      return !cmpntGroup["nodeInfo"]?.Read;
    }
    return value === "emailTab" || value === "dqTab";
  };

  return (
    <Fragment>
      <Card
        className={"w-100 app-settings-card"}
        style={{
          overflow: "auto",
          height: "89vh",
          border: "none",
          borderRadius: "unset",
          backgroundColor: "#333333",
        }}
      >
        <Card.Body
          className={"app-settings"}
          style={{ overflow: "hidden", padding: "0px" }}
        >
          <div
            className={
              "d-flex col-md-12 app_settings_sub_content configDetails"
            }
            style={{
              backgroundColor: "#fff",
              borderRadius: "5px",
              padding: "0px",
            }}
          >
            <div
              className={"col-md-2 config-menu"}
              style={{
                paddingRight: "15px",
                paddingLeft: "0px",
                backgroundColor: "#1e1e1e",
              }}
            >
              <Box
                component={"legend"}
                style={{ padding: "15px 15px 15px 10px" }}
                className="app-menu"
              >
                {appSetting.map((n, index) => (
                  <div className="menu-button" key={index}>
                    <Button
                      startIcon={n.icon}
                      style={{
                        backgroundColor:
                          render === n.value
                            ? "#242424"
                            : "#333333",
                        width: "100%",
                        color: "#fff",
                        margin: "5px 10px",
                        padding: "5px",
                        textTransform: "none",
                        height: "55px",
                        cursor: isButtonDisabled(n.value) ? "not-allowed" : "pointer",
                        borderBottom: render === n.value ? "3px solid white" : "none",
                        opacity: isButtonDisabled(n.value) ? 0.6 : 1, // makes it look dimmed but same style
                        display: "flex",
                        justifyContent: "left",
                        paddingLeft: "20px",                     }}
                      onClick={() => !isButtonDisabled(n.value) && appRender({ value: [n.value] })} // disable click
                    >
                      <b
                        style={{
                          padding: "6px",
                          fontWeight: render === n.value ? "bold" : "normal",
                          textDecoration: render === n.value ? "underline" : "none",
                        }}
                      >
                        {n.name}
                      </b>
                    </Button>

                  </div>
                ))}
              </Box>
              {/* <JobTable setLogs={setLogs} setWell={setWell} setRigsId={setRigsId}/> */}
            </div>
            <div className="col-md-10  p-0 h-100" style={{}}>
              {cmpntGroup["configuration"]?.Read && render === "cleanUpTab" && (
                <BackendJobs setTabs={setTabs} />
              )}
              {/* {cmpntGroup["teamNotification"]?.Read && render === "teamTab" && (
                <TeamNotify />
              )} */}
              {/* {render === "emailTab" && <EmailConfig />} */}
              {render === "keyValutTab" && <KeyVault />}
              {render === "clusterTab" && <Cluster />}
              {render === "teamTab" && <TeamNotify />}
              {render === "emailTab" && <EmailNotify />}
              {render === "rawDataTab" && <RawDataPersist />}
              {render === "dqTab" && <TemplateServer />}
              {cmpntGroup["nodeInfo"]?.Read && render === "nodeInfoTab" && (
                <NodeInfoPage />
              )}
              {cmpntGroup["dataProvider"]?.Read &&
                render === "dProvidersTab" && (
                  <DataQuality
                    dataProvider={dataProvider}
                    rigsData={rigsData}
                    bUnitData={bUnitData}
                    nodeInfo={nodeInfo}
                  />
                )}
              {/* <DataQuality selectedRig={activeRigId} setDQGraph={setDQGraph} activeWell={activeWells?.[activeRigId]?.["active_well_id"]} yhAddress={yhAddress} yhPort={yhPort} logs={logs} well={well} rigsId={rigsId}/> */}
            </div>
          </div>
          {/* </div> */}
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default ApplicationCnfig;
